import React, { useEffect, useState } from "react";
import { SmartTextField } from "./SmartTextField";
import { FullScreenDialog } from "../core/FullScreenDialog";
import { StatusDropDown } from "./StatusDropDown";
import { useSaveGame } from "@seabrookstudios/pitch2table";
import { Path } from "../Path";
import { useNavigate } from "react-router-dom";

const GameNameTextField = ({ onChange }) => {
  return (
    <SmartTextField required label="Game Name" helperText="A good pitch starts with a good name." onChange={onChange} />
  );
};

const GameTagTextField = ({ onChange }) => {
  return <SmartTextField label="Short pitch" helperText="Your game in one sentence." onChange={onChange} />;
};

/**
 * @param {object} props
 * @param {React.ReactNode} [props.CustomControl]
 */
export default function AddGameFullScreenDialog({ CustomControl = undefined }) {
  const navigate = useNavigate();

  const onSuccess = async (gameId) => {
    await navigate(Path.game(gameId).link());
  };

  const saveGame = useSaveGame(onSuccess);

  const [name, setName] = useState("");
  const [tag, setTag] = useState("");
  const [status, setStatus] = useState(
    /** @type {import("@seabrookstudios/pitch2table-core").DesignerGameStatus} */ ("Idea")
  );
  const [canSave, setCanSave] = useState(false);

  const onSaveHandler = async () => {
    await saveGame.mutateAsync({ name, tag, status });
  };

  useEffect(() => {
    setCanSave(!!name);
  }, [name, tag]);

  return (
    <FullScreenDialog
      title="Add Game"
      actionText="save"
      onSaveHandler={onSaveHandler}
      canSave={!canSave}
      isBusy={saveGame.isPending}
      CustomControl={CustomControl}
    >
      <GameNameTextField onChange={setName} />
      <GameTagTextField onChange={setTag} />
      <StatusDropDown value={status} onChange={setStatus} />
    </FullScreenDialog>
  );
}
